<template>
  <div>
    <div v-if="documentsObject">
      <view-file-item class="is-border is-margin-top-xsmall"
                      ref="viewFileItem"
                      v-if="displayDocument(documentsObject)"
                      :index="index"
                      :key="index + '-document'"
                      :document="documentsObject"
                      :canDrag="canDrag"
                      :fromFlux="fromFlux"
                      :canEdit="canEdit"
                      :canEditDisplay="canEditDisplay"
                      @update="updateDocument"
                      @delete="deleteDocument"
      ></view-file-item>
    </div>
    <div v-dragula="documents" drake="one" v-if="canDrag">
      <view-file-item class="is-border is-margin-top-xsmall "
                      ref="viewFileItem"
                      v-for="(document, index) in documents"
                      v-if="displayDocument(isArray ? document : document.document)"
                      :index="index"
                      :key="index + '-document-drag'"
                      :document="isArray ? document : document.document"
                      :canDrag="canDrag"
                      :fromFlux="fromFlux"
                      :canEdit="canEdit"
                      :canEditDisplay="canEditDisplay"
                      @update="updateDocument"
                      @delete="deleteDocument"
      ></view-file-item>
    </div>
    <div v-else-if="!canDrag">
      <view-file-item class="is-border is-margin-top-xsmall"
                      ref="viewFileItem"
                      v-for="(document, index) in documents"
                      v-if="displayDocument(isArray ? document : document.document)"
                      :index="index"
                      :key="index + '-document'"
                      :document="isArray ? document : document.document"
                      :canDrag="canDrag"
                      :fromFlux="fromFlux"
                      :canEdit="canEdit"
                      :canEditDisplay="canEditDisplay"
                      @update="updateDocument"
                      @delete="deleteDocument"
      ></view-file-item>
    </div>
    
  </div>
</template>

<script>
  import ViewFileItem from './ViewFileItem'
  import { mapGetters } from 'vuex'

  require('formdata-polyfill')

  export default {
    name: 'ViewFileList',
    components: {ViewFileItem},
    data () {
      return {
        documentCopy: null
      }
    },
    props: {
      ...ViewFileItem.props,
      documents: Array,
      documentsObject: Object,
      isArray: Boolean
    },
    computed: {
      ...mapGetters(['isAdmin'])
    },
    methods: {
      displayDocument (document) {
        return document && (this.isAdmin || document.display)
      },
      openPreview (selectedDocument) {
        let params = {
          source: selectedDocument
        }
        this.$store.commit('setModal', {mode: 'DOCUMENT_PREVIEW', params})
        // bus.$emit(EVENTS.OPEN_MODAL, {mode: 'DOCUMENT_PREVIEW', params})
      },
      updateDocument ({document, index}) {
        if (this.documents) {
          let documents = this.documents
          if (this.isArray) {
            this.$set(documents, [index], document)
          } else {
            this.$set(documents[index], 'document', document)
          }
          this.$emit('update', documents)
        } else if (this.documentsObject) {
          let documents = this.documentsObject
          documents = document
          this.$emit('update', documents)
        }
      },
      deleteDocument ({index}) {
        if (this.documents) {
          let documents = this.documents
          if (this.isArray) {
            documents.splice(index, 1)
          } else {
            this.$set(documents[index], 'document', null)
          }
          this.$emit('update', documents)
        } else if (this.documentsObject) {
          let documents = this.documentsObject
          documents = null
          this.$emit('update', documents)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/utils/ViewFileList.vue